import { TableColumn } from '../../../models/table-column';
import { TextKeys } from '../../../i18n/text-keys';
import { MaterialCatalogueColumnsEnum } from './material-catalogue-columns.enum';
import { ExpensesCatalogueColumnsEnum } from '../expenses-catalogue-items/expenses-catalogue-columns.enum';

export function getTableColumns(): TableColumn[] {
  return [
    {
      name: MaterialCatalogueColumnsEnum.Number,
      position: 0,
      selected: true,
      text: TextKeys.expenses.numberLong,
    },
    {
      name: MaterialCatalogueColumnsEnum.Name,
      position: 1,
      selected: true,
      text: TextKeys.expenses.name,
    },
    {
      name: MaterialCatalogueColumnsEnum.Description,
      position: 2,
      selected: true,
      text: TextKeys.expenses.description,
    },
    {
      name: MaterialCatalogueColumnsEnum.Quantity,
      position: 3,
      selected: true,
      text: TextKeys.quantity.quantity,
    },
    {
      name: MaterialCatalogueColumnsEnum.Unit,
      position: 4,
      selected: true,
      text: TextKeys.items.unit,
    },
    {
      name: ExpensesCatalogueColumnsEnum.Price,
      position: 5,
      selected: true,
      text: TextKeys.items.price,
    },
  ];
}
